import CustomScrollbar from 'components/CustomScrollbar';
import styled from 'styled-components';
import { blurBox } from 'styles/parcelSharedStyles';

export const Container = styled(CustomScrollbar)`
  position: relative;
  flex-grow: 1;
  height: 100%;
  ${blurBox};
`;
